import type { textLang } from "./App"

export interface Room {
  id: string
  roomTypeName: textLang
  price: number
  image: string
  description: textLang
  videoLink: string
}

export const rooms: Room[] = [
  {
    id: "superior-double",
    roomTypeName: {
      en: "Superior Double Bed",
      th: "ซุพีเรียร์ เตียงเดี่ยว",
    },
    price: 2100,
    image: "images/lightroom-1/DSC_0348.jpg",
    description: {
      th: `เตียงขนาด 6 ฟุต 1 เตียง
ขนาดห้อง 35 ตรม.`,
      en: `One 6 foot bed, room size 35 sqm.`,
    },
    videoLink: "https://www.facebook.com/reel/1092046842169375",
  },
  {
    id: "superior-twin",
    roomTypeName: {
      en: "Superior Twin Bed",
      th: "ซุพีเรียร์ เตียงคู่",
    },
    price: 2100,
    image: "images/lightroom-1/DSC_0349.jpg",
    description: {
      th: `เตียงขนาด 3.5 ฟุต 2 เตียง
ขนาดห้อง 35 ตรม.`,
      en: `Two 3.5 foot beds, room size 35 sqm.`,
    },
    videoLink: "https://www.facebook.com/reel/3642248479340832",
  },
  {
    id: "superior-triple",
    roomTypeName: {
      en: "Superior Triple Bed",
      th: "ซุพีเรียร์ สำหรับ 3 ท่าน",
    },
    price: 2500,
    image: "images/lightroom-1/DSC_0350.jpg",
    description: {
      th: `เตียงขนาด 6 และ 3.5 ฟุต อย่างละ 1 เตียง
ขนาดห้อง 35 ตรม.`,
      en: `1 bed each size 6 and 3.5 foot, room size 35 sqm.`,
    },
    videoLink: "https://www.facebook.com/reel/1011335643418022",
  },
]
